export default {
  ADD_USER(state, user) {
    state.users.collection.unshift(user);
  },

  DELETE_USER(state, id) {
    const index = state.users.collection.findIndex((user) => user.id === id);
    if (index >= 0) {
      state.users.collection.splice(index, 1);
    }
  },

  SET_USER(state, updatedUser) {
    const index = state.users.collection.findIndex((user) => user.id === updatedUser.id);
    if (index >= 0) {
      state.users.collection.splice(index, 1, updatedUser);
    }
  },

  SET_USERS(state, users) {
    state.users = users;
  },

  SET_EDITING_USER(state, editingUser) {
    state.editingUser = editingUser;
  },

  SET_AGENCIES(state, agencies) {
    state.allAgencies = agencies;
  },

  UPDATE_ROLES(state, roles) {
    state.allRoles = roles;
  },

  SET_INSTANCE_ID(state, instanceId) {
    state.instanceId = instanceId;
  },

  SET_LOADING(state, loading) {
    state.loading = loading;
  },

  SET_PAGE(state, page) {
    state.page = page;
  },

  SET_SORT_BY(state, sortBy) {
    state.sortBy = sortBy;
  },

  SET_ORDER_BY(state, orderBy) {
    state.orderBy = orderBy;
  },

  SET_SEARCH(state, search) {
    state.search = search;
  },
};
